export default {
  namespaced: true,
  log_incident: {
    title: "registro incidente | registros do incidentes",
    comment: "comentário",
  },
};
